import { differenceInYears } from "date-fns";
import { FormikProps } from "formik";
import get from "lodash-es/get";
import * as Yup from "yup";

import { IFormikProps as IFormikSignInProps } from "../components/Form/SignInForm/SignInForm.component";
import { IFormikProps as IFormikSignUpProps } from "../components/Form/SignUpForm/SignUpForm.component";
import { IFormikProps as IFormikShippingProps } from "../pages/OrderFunnel/Shipping/components/AddressSection/components/AddressesEditBlock/components/FormAddress.component";

import { translate } from "./translation.service";

export const getErrorMessage = (
  formikProps: FormikProps<
    IFormikShippingProps | IFormikSignInProps | IFormikSignUpProps
  >,
  path: string
): string | null => {
  const touched = get(formikProps.touched, path);
  const errors = get(formikProps.errors, path);

  if (touched && errors) {
    return errors;
  }

  return null;
};

export const isInputInvalid = <T>(
  formikProps: FormikProps<T>,
  path: string
): boolean => {
  return get(formikProps.touched, path) && get(formikProps.errors, path);
};

export const addressValidation = {
  city: Yup.string().required(() => translate("authentication.requiredField")),
  country: Yup.object().shape({
    name: Yup.string().required(() =>
      translate("authentication.requiredField")
    ),
  }),
  postcode: Yup.string()
    .trim()
    .test(
      "codeFormat",
      translate("authentication.enterValidPostalCode"),
      (val: string): boolean => {
        return /^[\S]{4,10}$/.test(val);
      }
    )
    .required(() => translate("authentication.enterValidPostalCode")),
  street: Yup.string().required(() =>
    translate("authentication.requiredField")
  ),
  telephone: Yup.string()
    .matches(/^\+?[\d]{8,12}$/, () =>
      translate("authentication.enterValidPhoneFormat")
    )
    .required(() => translate("authentication.requiredField")),
};

export const basicUserInfoValidation = {
  firstName: Yup.string().required(() =>
    translate("authentication.requiredField")
  ),
  lastName: Yup.string().required(() =>
    translate("authentication.requiredField")
  ),
};

export const emailValidation = {
  email: Yup.string()
    .email(() => translate("authentication.enterValidAddress"))
    .required(() => translate("authentication.enterValidAddress")),
};

export const extendedUserInfoValidation = {
  birthDate: Yup.string()
    .test(
      "userInfo.birthDate",
      () => translate("authentication.certifyAge"),
      (value: Yup.TestContext): boolean => {
        return differenceInYears(new Date(), new Date(value.toString())) >= 18;
      }
    )
    .required(() => translate("authentication.certifyAge")),
  ...emailValidation,
};

export const passwordValidation = {
  password: Yup.string()
    .trim()
    .min(6, () => translate("authentication.enterPasswordCharacters"))
    .required(() => translate("authentication.enterPasswordCharacters")),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref("password")], () =>
      translate("authentication.passwordMatch")
    )
    .required(() => translate("authentication.passwordMatch")),
};
